<template>
    <v-dialog v-model="show"
              :max-width="maxWidth"
              persistent
              disabled
    >
        <v-toolbar class="pr-2">
            <v-toolbar-title>{{toolbarTitle}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn left text @click.native="$emit('close')">Cancelar</v-btn>
            <v-btn v-if="selectable" left text @click.native="$emit('select', selected)">Aceptar</v-btn>
        </v-toolbar>
          <v-card class="pa-4">
          <PaginatedList
              :data-source-url="dataSourceUrl"
              :headers="headers"
              search-dto-url="no"
              :selectable="selectable"
              :value="selected"
              @input="$emit('update:selected', $event)"
              @itemClick="$emit('itemClick', $event)"
            ></PaginatedList>
          </v-card>
    </v-dialog>
</template>
<script>
    import PaginatedList from "./PaginatedList";
export default {
    name: "PaginatedListModal",
    components: { PaginatedList, },
    props: {
    value: {
      type: Boolean,
      default: () => false
    },
    toolbarTitle: String,
    maxWidth: {
      type: String,
      required: false
    },
    buttonCancelName: {
      type: String,
      default: () => "Cancelar"
    },
    dataSourceUrl: {
      type: String,
      required: true
    },
    headers: {
      type: Array,
      required: true
    },
    loadingMessage: {
      type: String,
      required: false,
      default: () => "Cargando"
    },
    errorMessage: {
      type: String,
      required: false,
      default: () => "No se pudo obtener los registros"
    },
    noDataMessage: {
      type: String,
      required: false,
      default: () => "No existen registros cargados"
    },
    selectable: {
      type: Boolean,
      default: () => false,
    },
    selected: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      show: false,
    };
  },
  mounted() {
    this.show = this.value;
  },
  methods: {
    onItemClick(itemClicked) {
      this.$emit("item-click", itemClicked);
    }
  },
  watch: {
    value() {
        if(this.readonly)
            this.show = false;
        else
            this.show = this.value;
    },
    show() {
        if(this.readonly)
            this.show = false;
        else
            this.show !== this.value && this.$emit("input", this.show);
    }
  },
    beforeCreate: function () {
        this.$options.components.PaginatedList = require('./PaginatedList.vue').default
    }
};
</script>

